<template>
  <div style="height: 100%; overflow: hidden">
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Phản hồi" :link="[{ text: 'Phản hồi', href: '../feedback' }]" />
      </div>
    </div>

    <div class="mb-8">
      <v-card class="mx-4 pa-6" elevation="0" outlined>
        <TeacherFeedbackFilter @onFilterChanged="onFilterChanged" />
      </v-card>
    </div>

    <div v-if="firstLoadData || (messageGroups && messageGroups.length)">
      <v-row class="pb-4">
        <!-- message group -->
        <v-col cols="12" md="4">
          <div
            v-infinite-scroll="loadMore"
            :infinite-scroll-disabled="busy"
            class="message-group px-4"
            :style="{ height: windowHeight - 300 + 'px !important' }"
          >
            <v-row>
              <v-col v-for="(group, index) in messageGroups" :key="index" cols="12">
                <v-hover v-slot="{ hover }" open-delay="200">
                  <v-card
                    :class="{ 'on-hover': hover, selected: group.selected }"
                    outlined
                    @click="groupClicked(group)"
                  >
                    <v-card-text>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div style="width: 100%">
                            <span v-bind="attrs" v-on="on">
                              <div class="truncate-text">
                                {{ group | getTeacherNames }}
                              </div>
                              <CardStudentName :student="group.student" class="ml-n2 mt-n2" />

                              <div class="truncate-text">
                                {{ group | getLastMessageContent }}
                              </div>
                            </span>
                          </div>
                        </template>
                        <span
                          >{{ group.student.name }} - Lớp {{ group | _get('class.title', 'Không có') }} -
                          {{ group.name }}</span
                        >
                      </v-tooltip>
                    </v-card-text>
                  </v-card>
                </v-hover>
              </v-col>
              <v-col>
                <div v-if="busy">
                  <v-skeleton-loader type="card-avatar, article"></v-skeleton-loader>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>

        <!-- chat -->
        <v-col cols="12" md="8" v-if="messageGroup && messageGroup.id" class="div-border mt-3 pr-4">
          <div id="chat" v-if="!messageLoading">
            <div class="d-flex align-center justify-space-between mb-4">
              <div class="text-h5 primary--text">Phụ huynh em {{ messageGroup | _get('student.name') }}</div>
              <router-link class="mr-4" style="text-decoration: none" :to="'/student/' + messageGroup.student.id">
                Xem hồ sơ
              </router-link>
            </div>
            <div
              v-chat-scroll="{ always: false, scrollonremoved: true }"
              id="messages-window"
              :style="{ height: windowHeight - 400 + 'px !important' }"
            >
              <div v-for="message in messages" :key="message.id" id="message-container">
                <div v-if="message.data && message.data.type === 'other'" style="align-self: center">
                  <span class="text-caption">
                    {{ message.content }}
                  </span>
                </div>
                <div v-else :class="'message-container ' + (message.sender.type !== 'student' ? 'sender' : '')">
                  <div
                    v-if="message.image"
                    :class="'message ' + (message.sender.type !== 'student' ? 'ours' : '')"
                    :style="{
                      background: `${message.image && message.image.url ? 'transparent' : ''} !important`,
                      'text-align': message.sender.type !== 'student' ? 'end' : ''
                    }"
                  >
                    <img v-img :src="message.image.url" class="image-message sender" />
                    <br />
                  </div>
                  <div
                    v-if="message.content"
                    :class="'message ' + (message.sender.type !== 'student' ? 'ours' : '')"
                    :style="{}"
                  >
                    <span>
                      {{ message.content }}
                    </span>
                  </div>
                </div>

                <!-- time -->
                <div v-if="message.data && message.data.type === 'other'" class="time" style="align-self: center">
                  <span class="text-caption">
                    {{ message.time | getDisplayTime }}
                  </span>
                </div>
                <div v-else :class="'time ' + (message.sender.type !== 'student' ? 'sender' : '')">
                  {{ message.time | getDisplayTime }}
                </div>
              </div>
            </div>
            <v-row>
              <v-col class="pt-4 pl-8" cols="1">
                <v-file-input
                  :disabled="role.type !== 'manager'"
                  dense
                  accept="image/png, image/jpeg, image/bmp"
                  prepend-icon="mdi-camera"
                  hide-input
                  @change="onChange"
                ></v-file-input>
              </v-col>
              <v-col cols="11">
                <v-text-field
                  v-model="content"
                  :disabled="sending || role.type !== 'manager'"
                  :loading="sending"
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-send"
                  type="text"
                  class="input"
                  @click:append="send()"
                  @keyup.enter="send()"
                />
              </v-col>
            </v-row>
          </div>
          <div v-else>
            <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
          </div>
        </v-col>
        <v-col v-else class="d-flex justify-center align-center mr-8 mt-3 div-border">
          <div>Vui lòng chọn cuộc hội thoại</div>
        </v-col>
      </v-row>
    </div>

    <div class="text-h5 d-flex text-center justify-center align-center" style="height: 100%; overflow: hidden" v-else>
      Chưa có phản hồi từ phụ huynh
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { textHelpers } from '@/helpers/TextHelper.js'
import TeacherFeedbackFilter from '@/modules/feedback/TeacherFeedbackFilter.vue'
import Vue from 'vue'
import VueChatScroll from 'vue-chat-scroll'
import moment from 'moment'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import VueImg from 'v-img'
import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)
Vue.use(VueImg)
Vue.use(VueChatScroll)

export default {
  components: {
    Breadcrumbs,
    CardStudentName,
    TeacherFeedbackFilter
  },
  data() {
    return {
      windowHeight: window.innerHeight,
      content: '',
      interval: null,
      sending: false,
      busy: false,
      messageGroupParams: {},
      firstLoadData: false,
      messageLoading: false,
      reloadCurrentRoom: false,
      searchParams: {}
    }
  },
  async created() {
    this.firstLoadData = true

    this.messageGroupParams = {
      type: 'teacher'
    }
    await this.fetchMessageGroups({ ...this.messageGroupParams, _limit: 15 })

    if (this.$route.params.id) {
      const group = this.messageGroups.find(g => g.id === this.$route.params.id)
      if (group && group.id) await this.groupClicked(group)
      else this.$router.push(`/teacher-feedback`)
    }
    this.firstLoadData = false

    // interval fetch messages
    this.interval = setInterval(async () => {
      if (!this.reloadCurrentRoom) {
        await this.fetchMessageGroups({ ...this.messageGroupParams, _limit: this.messageGroups.length })
        if (this.messageGroup.id) {
          await this.fetchMessages(this.messageGroup)
        }
      } else {
        // reload current result when filter
        await this.fetchMessageGroups(this.searchParams)
        if (this.messageGroup.id) {
          await this.fetchMessages(this.messageGroup)
        }
      }
    }, 60000)
  },

  computed: {
    ...mapState('TeacherFeedback', ['messages', 'messageGroup', 'groupNo']),
    ...mapGetters('TeacherFeedback', ['messageGroups']),
    ...mapGetters('auth', ['profile', 'role']),
    ...mapGetters('constant', ['messageMemberType'])
  },
  methods: {
    ...mapActions('TeacherFeedback', [
      'fetchMessageGroups',
      'fetchMessages',
      'createMessage',
      'uploadImage',
      'searchMessageGroups'
    ]),

    async onFilterChanged(params) {
      if (!params.class && !params.student) this.reloadCurrentRoom = false
      else this.reloadCurrentRoom = true

      params.type = 'teacher'
      params['_limit'] = -1
      this.searchParams = params

      await this.searchMessageGroups(params)
    },
    onChange(file) {
      if (file) {
        if (typeof this.$rules.imageChat(file) === 'string') {
          this.$alert.error(this.$rules.imageChat(file))
          return
        }
        this.send(file)
      }
    },
    async send(image) {
      if (this.sending || (!image && (!this.content || !textHelpers.removeSpaces(this.content)))) return

      const data = {
        time: moment().toISOString(),
        content: this.content,
        sender: this.profile.user,
        messageGroup: this.messageGroup.id
      }
      try {
        this.sending = true
        const createdMessage = await this.createMessage(data)

        if (image) {
          // image
          let formData = new FormData()
          formData.append('files', image)
          formData.append('refId', createdMessage.id)
          formData.append('ref', 'message')
          formData.append('field', 'image')

          this.uploadImage(formData)
        }

        if (!image) this.content = ''
      } catch (error) {
        this.$alert.error('Gửi thất bại, vui lòng thử lại')
      } finally {
        this.sending = false
      }
    },
    loadMore() {
      if (this.messageGroups.length < this.groupNo && !this.busy) {
        this.busy = true

        setTimeout(async () => {
          await this.fetchMessageGroups({ ...this.messageGroupParams, _limit: this.messageGroups.length + 10 })
          this.busy = false
        }, 1500)
      }
    },
    onResize() {
      this.windowHeight = window.innerHeight
    },
    async groupClicked(group) {
      this.messageLoading = true
      const messageGroup = { ...group, isUpdateLastSeen: true }
      await this.fetchMessages(messageGroup)
      this.messageLoading = false
      if (this.$route.params.id !== group.id) this.$router.push(`/teacher-feedback/${group.id}`)
    }
  },
  filters: {
    getDisplayTime(time) {
      if (moment(time).isBetween(moment().startOf('day'), moment().endOf('day'))) {
        // today
        return moment(time).format('HH:mm')
      } else if (moment(time).year === moment().year) {
        return moment(time).format('DD/MM HH:mm')
      } else {
        return moment(time).format('DD/MM/YYYY HH:mm')
      }
    },
    getTeacherNames(messageGroup) {
      if (messageGroup.class && messageGroup.class.headTeachers && messageGroup.class.headTeachers.length) {
        return messageGroup.name
      }

      return 'Chưa có GVCN'
    },
    getLastMessageContent(messageGroup) {
      if (messageGroup.lastMessage && messageGroup.lastMessage.image) return 'Đã gửi 1 ảnh'
      return messageGroup.lastMessage && messageGroup.lastMessage.content
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    clearInterval(this.interval)
  }
}
</script>

<style scoped>
#chat {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-flow: column;
}

#messages-window {
  background: #eee;
  overflow: auto;
  padding: 20px;
}

#message-container {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.message-container {
  /* padding: 8px 12px; */
  max-width: 70%;
}

.sender {
  align-self: flex-end;
}

.message {
  background: gray;
  color: white;
  padding: 8px 12px;
  border-radius: 16px;
  word-wrap: break-word;
}

.time {
  /* white-space: nowrap; */
  color: grey;
  font-size: 11px;
  margin-bottom: 16px;
}

.ours {
  background: #0076ff;
}

.message-group {
  overflow: auto;
}

.input {
  /* background-color: lightblue; */
}

.truncate-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  -webkit-box-orient: vertical;
}

.selected {
  background: lightsteelblue;
}

.image-message {
  width: 70%;
  object-fit: contain;
  cursor: pointer;
}
.div-border {
  outline: 1px solid #d3d3d3;
}
.on-hover {
  border: 1px solid #8ca8f7;
}
</style>
